<template lang="pug">
  .code-type.col-sm-12
    .panel.panel-default.col-sm-3(:key="index" v-for="(t, index) in type")
      .panel-body.text-center
        img(:src="t.img")
        p.description {{t.text}}
        button.btn.btn-lg.btn-primary(@click="selectCodeType(t.button.value, index)") {{t.button.text}}

</template>

<script>
import iconQr from '@/assets/icon-qr.png'
import iconDocument from '@/assets/icon-document.png'

export default {
  props: {
    pair: {
      type: Number
    }
  },
  data() {
    const pairOrGenerate = this.pair > 0 ? 'Pair with ' : 'Generate '
    return {
      type: [
        {
          img: iconQr,
          text: `${pairOrGenerate} a new set of Kezzler Codes`,
          button: { text: 'Generate Codes', value: 'KZ' }
        },
        {
          img: iconDocument,
          text: `${pairOrGenerate} existing code from a file`,
          button: { text: 'External Codes', value: 'EXT' }
        }
      ]
    }
  },
  methods: {
    selectCodeType(value) {
      this.$emit('type', value)
    }
  },
  components: {
    iconQr,
    iconDocument
  }
}
</script>

<style lang="scss">
.code-type {
  display: flex;
  align-items: center;
  justify-content: center;

  .panel {
    margin-left: 10px;
  }

  img {
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/code/components/CodeType.vue